import { render } from "./submitTips.vue?vue&type=template&id=e72e5f6c&scoped=true&ts=true"
import script from "./submitTips.vue?vue&type=script&lang=ts"
export * from "./submitTips.vue?vue&type=script&lang=ts"

import "./submitTips.vue?vue&type=style&index=0&id=e72e5f6c&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72e5f6c"]])

export default __exports__